/* eslint-disable max-len */
import React from 'react';

const MassOperationsMenu: React.FC<object> = () => {
    return (
        <svg
            width="16"
            height="14"
            viewBox="0 0 16 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M0 1.16667C0 0.857247 0.120408 0.560501 0.334735 0.341709C0.549062 0.122917 0.839753 0 1.14286 0L14.8571 0C15.1602 0 15.4509 0.122917 15.6653 0.341709C15.8796 0.560501 16 0.857247 16 1.16667C16 1.47609 15.8796 1.77283 15.6653 1.99162C15.4509 2.21042 15.1602 2.33333 14.8571 2.33333H1.14286C0.839753 2.33333 0.549062 2.21042 0.334735 1.99162C0.120408 1.77283 0 1.47609 0 1.16667ZM0 7C0 6.69058 0.120408 6.39383 0.334735 6.17504C0.549062 5.95625 0.839753 5.83333 1.14286 5.83333H14.8571C15.1602 5.83333 15.4509 5.95625 15.6653 6.17504C15.8796 6.39383 16 6.69058 16 7C16 7.30942 15.8796 7.60617 15.6653 7.82496C15.4509 8.04375 15.1602 8.16667 14.8571 8.16667H1.14286C0.839753 8.16667 0.549062 8.04375 0.334735 7.82496C0.120408 7.60617 0 7.30942 0 7ZM0 12.8333C0 12.5239 0.120408 12.2272 0.334735 12.0084C0.549062 11.7896 0.839753 11.6667 1.14286 11.6667H14.8571C15.1602 11.6667 15.4509 11.7896 15.6653 12.0084C15.8796 12.2272 16 12.5239 16 12.8333C16 13.1428 15.8796 13.4395 15.6653 13.6583C15.4509 13.8771 15.1602 14 14.8571 14H1.14286C0.839753 14 0.549062 13.8771 0.334735 13.6583C0.120408 13.4395 0 13.1428 0 12.8333Z"
                fill="currentColor"
            />
        </svg>
    );
};

export default MassOperationsMenu;